module.exports = __webpack_public_path__ + "static/media/Ellipse 2.e1f2c3c6.png";